import { handleActions } from 'redux-actions';
import actions from './actions';
import produce from 'immer';
import { updateStoreWithPath } from '../../../lib/common';
import { _LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../app/models';
import { VERSION_DETAIL_MODEL, VERSION_LIST_SEARCH_OPTION_MODEL, VERSION_LIST_SORT_OPTION_MODEL } from './model';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  버전 리스트
   */
  versionList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: VERSION_LIST_SEARCH_OPTION_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: VERSION_LIST_SEARCH_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: VERSION_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },
  /**
   *  버전 상세
   */
  versionDetail: VERSION_DETAIL_MODEL,
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [버전] 버전 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },
    /**
     *  [버전 전체 리스트] 버전 리스트 받아오기
     */
    [actions.GET_VERSION_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  버전 전체 리스트
         */
        draft.versionList = {
          ...draft.versionList,
          ...action.payload.versionList,
        };
      });
    },
    /**
     *  [버전 상세] 버전 상세 요청하기
     */
    [actions.GET_VERSION_INFO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.versionDetail = {
          ...action.payload.versionDetail,
        };
      });
    },
  },
  initialState,
);
